/**
 * Client-side mirror of the server's DEFAULT_THEME. The server is the
 * authoritative source for client-specific theme data; this constant
 * exists only so the portal can paint *something* before the server
 * fetch resolves, and as a last-resort fallback if that fetch fails.
 *
 * Shape must stay in sync with `server/src/modules/oidc/theme.ts`.
 */

export interface ClientThemeColors {
  readonly primary: string;
  readonly primaryHover: string;
  readonly background: string;
  readonly text: string;
  readonly textMuted: string;
}

export interface ClientThemeCopy {
  readonly loginTitle: string;
  readonly signupTitle: string;
  readonly footerNote: string;
}

export interface ClientTheme {
  readonly slug: string;
  readonly displayName: string;
  readonly logoUrl: string;
  readonly colors: ClientThemeColors;
  readonly copy: ClientThemeCopy;
}

export const DEFAULT_THEME: ClientTheme = Object.freeze({
  slug: 'default',
  displayName: 'Crengine',
  logoUrl: '/assets/crengine-logo.svg',
  colors: Object.freeze({
    primary: '#4a90d9',
    primaryHover: '#3a7bc8',
    background: '#f5f5f5',
    text: '#222222',
    textMuted: '#666666',
  }),
  copy: Object.freeze({
    loginTitle: 'Sign In',
    signupTitle: 'Create Account',
    footerNote: 'Powered by Crengine',
  }),
}) as ClientTheme;
